import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { cn } from "../../utils";
import { Button } from "./Button";
import { Calendar } from "./Calendar";
import { FormControl } from "./Form";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
export const DatePicker = props => {
    const { value, onChange, placeholder = "select date" } = props;
    return (_jsxs(Popover, { modal: true, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(FormControl, { children: _jsxs(Button, { variant: "outline", className: cn("w-[240px] pl-3 text-left font-normal", value && "text-muted-foreground"), children: [value ? format(value, "PPP") : _jsx("span", { children: placeholder }), _jsx(CalendarIcon, { className: "ml-auto h-4 w-4 opacity-50" })] }) }) }), _jsx(PopoverContent, { className: "w-auto p-0", align: "start", children: _jsx(Calendar, { mode: "single", selected: value, onSelect: onChange, disabled: date => date < new Date(), initialFocus: true }) })] }));
};
